import { EduElse, EduIf, EduThen, withWindowSizes } from '@edulastic/common'
import { IconFilter, IconItemLibrary } from '@edulastic/icons'
import { withNamespaces } from '@edulastic/localization'
import { roleuser, sortOptions, testTypes } from '@edulastic/constants'
import { Pagination, Spin } from 'antd'
import _, { debounce, omit, isEqual } from 'lodash'
import moment from 'moment'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { storeInLocalStorage } from '@edulastic/api/src/utils/Storage'
import {
  LIBRARY_TYPES,
  sessionFilters as sessionFilterKeys,
} from '@edulastic/constants/const/common'
import { TEST_TYPE_SURVEY } from '@edulastic/constants/const/testTypes'
import { LIKERT_SCALE } from '@edulastic/constants/const/questionType'
import { MORE_ITEM_TYPES } from '@edulastic/constants/const/addQuestionQuickLinks'
import { SMART_FILTERS } from '@edulastic/constants/const/filters'
import produce from 'immer'
import { segmentApi } from '@edulastic/api'
import FeaturesSwitch from '../../../../features/components/FeaturesSwitch'
import {
  updateDefaultGradesAction,
  updateDefaultSubjectAction,
} from '../../../../student/Login/ducks'
import {
  clearDictStandardsAction,
  getDictCurriculumsAction,
  getDictStandardsForCurriculumAction,
} from '../../../src/actions/dictionaries'
import { createTestItemAction } from '../../../src/actions/testItem'
import ListHeader from '../../../src/components/common/ListHeader'
import { SMALL_DESKTOP_WIDTH } from '../../../src/constants/others'
import {
  getCurriculumsListSelector,
  getStandardsListSelector,
} from '../../../src/selectors/dictionaries'
import { getTestItemCreatingSelector } from '../../../src/selectors/testItem'
import {
  getAllInterestedCurriculumsSelector,
  getCollectionsSelector,
  getDefaultGradesSelector,
  getDefaultSubjectSelector,
  getInterestedGradesSelector,
  getInterestedSubjectsSelector,
  getUserFeatures,
  getUserId,
  getUserOrgId,
  getUserRole,
  isSemanticSearchEnabledSelector,
  isDistrictContentFilterEnabledSelector,
} from '../../../src/selectors/user'
import {
  ItemsMenu,
  PaginationInfo,
} from '../../../TestList/components/Container/styled'
import {
  filterMenuItems,
  getTestItemsLoadingSelector,
  getTestsItemsCountSelector,
  getTestsItemsLimitSelector,
  getTestsItemsPageSelector,
  initialSearchState,
  receiveTestItemsAction,
  updateSearchFilterStateAction,
  getSelectedItemSelector,
  setApproveConfirmationOpenAction,
  getSortFilterStateSelector,
  initialSortState,
  getSearchIdSelector,
} from '../../../TestPage/components/AddItems/ducks'
import {
  getAllTagsAction,
  previewCheckAnswerAction,
  previewShowAnswerAction,
  setDefaultTestDataAction,
  getDefaultTestSettingsAction,
  setTestDataAction,
} from '../../../TestPage/ducks'
import {
  approveOrRejectMultipleItem as approveOrRejectMultipleItemAction,
  createTestFromCartAction,
} from '../../ducks'
import Actions from '../Actions'
import SelectCollectionModal from '../Actions/SelectCollection'
import CartButton from '../CartButton/CartButton'
import ItemFilter from '../ItemFilter/ItemFilter'
import ItemListContainer from './ItemListContainer'
import {
  Container,
  ContentWrapper,
  Element,
  ListItems,
  MobileFilterIcon,
  PaginationContainer,
  ScrollbarContainer,
} from './styled'
import {
  setDefaultInterests,
  shouldUseRelevanceSortForEntireLibrary,
} from '../../../dataUtils'
import { trackSearchZeroResults } from '../../../constants/librarySearchSegment'
import HeaderFilter from '../HeaderFilter'
import SideContent from '../../../Dashboard/components/SideContent/Sidecontent'
import ApproveConfirmModal from '../ApproveConfirmModal'
import SortMenu from '../SortMenu'
import {
  getFilterFromSession,
  setFilterInSession,
} from '../../../../common/utils/helpers'
import { getTestEntitySelector } from '../../../AssignTest/duck'
import { StyledEduButton } from '../../../Reports/common/styled'
import FilterToggleBtn from '../../../src/components/common/FilterToggleBtn'
import { FeatureBannerPlaceholder } from '../../../FeatureBanner'
import {
  getFilterType,
  getMatchingFilterObjects,
  normalizeSearchTags,
  isLibraryScopeFilter,
  persistSearchFilterToSession,
} from '../../../TestPage/components/AddItems/utils'
import SearchInputWithTooltip from '../ItemFilter/SearchInputWithTooltip'

// container the main entry point to the component
class Contaier extends Component {
  constructor(props) {
    super(props)
    this.lastItemSearchFilter = null

    const lastVisistedLibrary = getFilterFromSession({
      key: sessionFilterKeys.LAST_VISITED_LIBRARY,
      districtId: this.props.districtId,
      userId: this.props.userId,
    })

    if (
      lastVisistedLibrary !== LIBRARY_TYPES.ITEM &&
      !_.isEmpty(lastVisistedLibrary)
    ) {
      ;[
        sessionFilterKeys[`SEARCH_FILTER_${SMART_FILTERS.ENTIRE_LIBRARY}`],
        sessionFilterKeys[
          `SEARCH_FILTER_${SMART_FILTERS.DISTRICT_CERTIFIED_LIBRARY}`
        ],
        sessionFilterKeys[`SEARCH_FILTER_${SMART_FILTERS.CERTIFIED_CONTENT}`],
        sessionFilterKeys[`SEARCH_FILTER_${SMART_FILTERS.AUTHORED_BY_ME}`],
        sessionFilterKeys[`SEARCH_FILTER_${SMART_FILTERS.SHARED_WITH_ME}`],
        sessionFilterKeys[`SEARCH_FILTER_${SMART_FILTERS.CO_AUTHOR}`],
        sessionFilterKeys[`SEARCH_FILTER_${SMART_FILTERS.PREVIOUSLY_USED}`],
        sessionFilterKeys[`SEARCH_FILTER_${SMART_FILTERS.FAVORITES}`],
        sessionFilterKeys[`SEARCH_FILTER_${SMART_FILTERS.FOLDERS}`],
      ].forEach((key) => {
        setFilterInSession({
          key,
          filter: {
            ...getFilterFromSession({
              key,
              districtId: this.props.districtId,
              userId: this.props.userId,
            }),
            curriculumId: '',
            standardIds: [],
          },
          userId: this.props.userId,
          districtId: this.props.districtId,
        })
      })
    }

    const lastFilter = getFilterFromSession({
      key: sessionFilterKeys.TEST_ITEM_FILTER,
      districtId: this.props.districtId,
      userId: this.props.userId,
    })

    let lastFolderId
    const lastFilterCategory = lastFilter.filter || SMART_FILTERS.ENTIRE_LIBRARY
    if (lastFilterCategory === SMART_FILTERS.FOLDERS) {
      lastFolderId = lastFilter.folderId
    }
    this.state = {
      isShowFilter: true,
      openSidebar: false,
      filter: {
        ...produce(initialSearchState, (draft) => {
          return draft
        }),
        ...(lastFilterCategory === SMART_FILTERS.FOLDERS
          ? { filter: SMART_FILTERS.FOLDERS, folderId: lastFolderId }
          : getFilterFromSession({
              key: sessionFilterKeys[`SEARCH_FILTER_${lastFilterCategory}`],
              districtId: this.props.districtId,
              userId: this.props.userId,
            })),
      },
    }

    setFilterInSession({
      key: sessionFilterKeys.LAST_VISITED_LIBRARY,
      districtId: this.props.districtId,
      userId: this.props.userId,
      filter: LIBRARY_TYPES.ITEM,
    })
  }

  componentDidMount() {
    const {
      receiveItems,
      curriculums,
      getCurriculums,
      getCurriculumStandards,
      match = {},
      limit,
      setDefaultTestData,
      getAllTags,
      history,
      sort: initSort = {},
      userId,
      districtId,
      test,
      getDefaultTestSettings,
      userRole,
      setTestData,
    } = this.props

    const initSearch = this.state.filter

    const isAuthoredNow = history?.location?.state?.isAuthoredNow
    const applyAuthoredFilter = isAuthoredNow
      ? { filter: 'AUTHORED_BY_ME' }
      : {}
    const { params = {} } = match
    const sessionSort = getFilterFromSession({
      key: sessionFilterKeys.TEST_ITEM_SORT,
      userId,
      districtId,
    })
    const search = {
      ...initSearch,
      ...applyAuthoredFilter,
    }
    const sort = {
      ...initSort,
      sortBy:
        search.filter === SMART_FILTERS.ENTIRE_LIBRARY &&
        shouldUseRelevanceSortForEntireLibrary(this.props)
          ? 'relevance'
          : 'popularity',
      sortDir: 'desc',
      ...sessionSort,
    }
    if (search.questionType === LIKERT_SCALE) {
      search.questionType = ''
    }
    if (test && test._id) {
      setDefaultTestData()
    } else if (userRole !== roleuser.EDULASTIC_CURATOR) {
      getDefaultTestSettings()
      if (test?.testType === TEST_TYPE_SURVEY) {
        setTestData({
          testType: testTypes.TEST_TYPES_VALUES_MAP.ASSESSMENT,
          updated: false,
        })
      }
    }
    getAllTags({ type: 'testitem' })
    if (params.filterType) {
      const getMatchingObj = getMatchingFilterObjects({
        filterMenuItems,
        filterPath: params.filterType,
      })
      const { filter = '' } = (getMatchingObj.length && getMatchingObj[0]) || {}
      const updatedSearch = { ...search, filter }

      if (filter === filterMenuItems[0].filter) {
        updatedSearch.status = ''
      }
      this.updateFilterState(updatedSearch, sort)

      this.lastItemSearchFilter = updatedSearch
      receiveItems(updatedSearch, sort, 1, limit)
    } else {
      this.updateFilterState(search, sort)
      this.lastItemSearchFilter = search
      receiveItems(search, sort, 1, limit)
    }
    if (curriculums.length === 0) {
      getCurriculums()
    }
    if (search.curriculumId) {
      getCurriculumStandards(search.curriculumId, search.grades, '')
    }
  }

  updateFilterState = (newSearch, sort = {}) => {
    const { updateSearchFilterState, userId, districtId } = this.props
    updateSearchFilterState({ sort })

    persistSearchFilterToSession({
      searchFilter: newSearch,
      userId,
      districtId,
      sessionFilterKeys,
    })

    this.setState({ filter: newSearch })
    setFilterInSession({
      key: sessionFilterKeys.TEST_ITEM_FILTER,
      filter: { filter: newSearch.filter, folderId: newSearch.folderId },
      districtId,
      userId,
    })
    setFilterInSession({
      key: sessionFilterKeys.TEST_ITEM_SORT,
      filter: sort,
      userId,
      districtId,
    })
  }

  handleSearch = (searchState) => {
    const { limit, receiveItems, userFeatures, sort } = this.props
    const { filter: propSearch } = this.state
    let search = searchState || propSearch
    if (!userFeatures.isCurator) search = omit(search, 'authoredByIds')
    this.lastItemSearchFilter = search
    receiveItems(search, sort, 1, limit)
  }

  handleLabelSearch = (e) => {
    const { limit, receiveItems, history } = this.props
    const filterState = this.state.filter
    const { key: filterType } = e
    const getMatchingObj = getMatchingFilterObjects({
      filterMenuItems,
      filterPath: filterType,
    })
    const { filter = '' } = (getMatchingObj.length && getMatchingObj[0]) || {}
    let updatedSearch = omit(
      filter === filterState.filter
        ? filterState
        : {
            ...produce(initialSearchState, (draft) => {
              return draft
            }),
            ...(filter === SMART_FILTERS.FOLDERS
              ? {}
              : getFilterFromSession({
                  key: sessionFilterKeys[`SEARCH_FILTER_${filter}`],
                  districtId: this.props.districtId,
                  userId: this.props.userId,
                })),
          },
      ['folderId']
    )

    updatedSearch.filter = filter

    if (
      filter !== filterState.filter &&
      isLibraryScopeFilter(filter) &&
      isLibraryScopeFilter(filterState.filter)
    ) {
      updatedSearch = {
        ...updatedSearch,
        ...omit(filterState, ['filter', 'folderId']),
        filter,
      }
    }

    if (filter === filterMenuItems[0].filter) {
      updatedSearch = {
        ...updatedSearch,
        status: '',
      }
    }
    const sortByRecency = ['by-me', 'shared'].includes(filterType)
    const sortByRelevance =
      filter === SMART_FILTERS.ENTIRE_LIBRARY &&
      shouldUseRelevanceSortForEntireLibrary(this.props)
    const sort = {
      sortBy: sortByRecency
        ? 'recency'
        : sortByRelevance
        ? 'relevance'
        : 'popularity',
      sortDir: 'desc',
    }
    this.updateFilterState(updatedSearch, sort)

    if (filterType !== 'folders') {
      this.lastItemSearchFilter = updatedSearch
      receiveItems(updatedSearch, sort, 1, limit)
    }

    history.push(`/author/items/filter/${filterType}`)
  }

  handleClearSearch = () => {
    const { limit, receiveItems, sort = {} } = this.props
    const { filter = {} } = this.state
    const clearedSort = {
      ...initialSortState,
      sortBy:
        filter.filter === SMART_FILTERS.ENTIRE_LIBRARY &&
        shouldUseRelevanceSortForEntireLibrary(this.props)
          ? 'relevance'
          : initialSortState.sortBy,
    }

    const clearedFilters = produce(initialSearchState, (draft) => {
      draft.filter = filter.filter
    })

    // If current filter and initial filter is equal don't need to reset again
    if (isEqual(filter, clearedFilters) && isEqual(sort, clearedSort))
      return null

    this.updateFilterState(clearedFilters, clearedSort)
    this.lastItemSearchFilter = clearedFilters
    receiveItems(clearedFilters, clearedSort, 1, limit)
    setDefaultInterests({ subject: [], grades: [], curriculumId: '' })
  }

  handleSearchFieldChangeCurriculumId = (value) => {
    const { clearDictStandards, getCurriculumStandards, sort } = this.props
    const { filter } = this.state
    clearDictStandards()
    const updatedSearchValue = {
      ...filter,
      curriculumId: value,
      standardIds: [],
    }
    this.updateFilterState(updatedSearchValue, sort)
    this.handleSearch(updatedSearchValue)
    getCurriculumStandards(value, filter.grades, '')
  }

  handleSearchFieldChange = (fieldName) => (value, dateString) => {
    const {
      updateDefaultGrades,
      udpateDefaultSubject,
      clearDictStandards,
      getCurriculumStandards,
      sort,
    } = this.props
    const { filter } = this.state
    let updatedKeys = {}
    if (fieldName === 'folderId') {
      const searchWithFolder = {
        ...initialSearchState,
        [fieldName]: value,
        filter: 'FOLDERS',
      }
      this.updateFilterState(searchWithFolder, sort)
      return this.handleSearch(searchWithFolder)
    }
    if (
      fieldName === 'grades' ||
      fieldName === 'subject' ||
      fieldName === 'curriculumId'
    ) {
      setDefaultInterests({ [fieldName]: value })
    }
    if (fieldName === 'curriculumId') {
      this.handleSearchFieldChangeCurriculumId(value)
      return
    }
    if (fieldName === 'grades' && filter.curriculumId) {
      clearDictStandards()
      getCurriculumStandards(filter.curriculumId, value, '')
    }
    if (fieldName === 'subject') {
      clearDictStandards()
      udpateDefaultSubject(value)
      updatedKeys = {
        ...filter,
        [fieldName]: value,
        curriculumId: '',
        standardIds: [],
      }
    }
    if (fieldName === 'createdAt') {
      updatedKeys = {
        ...filter,
        [fieldName]: value ? moment(dateString, 'DD/MM/YYYY').valueOf() : '',
      }
    } else {
      updatedKeys = {
        ...filter,
        ...updatedKeys, // To retain the changes for the related fields done in previous steps.
        [fieldName]: value,
      }
    }

    if (fieldName === 'grades') {
      updateDefaultGrades(value)
      storeInLocalStorage('defaultGrades', value)
    }

    this.updateFilterState(updatedKeys, sort)
    this.handleSearch(updatedKeys)
  }

  searchDebounce = debounce(this.handleSearch, 500)

  handleSearchInputChange = (tags) => {
    const { sort } = this.props
    const { filter } = this.state
    const updatedKeys = {
      ...filter,
      searchString: normalizeSearchTags(tags),
    }

    this.updateFilterState(updatedKeys, sort)
    this.searchDebounce()
  }

  handleCreate = async (quickLinkQuestionType) => {
    const { createItem } = this.props
    createItem(
      {
        rows: [
          {
            tabs: [],
            dimension: '100%',
            widgets: [],
            flowLayout: false,
            content: '',
          },
        ],
      },
      { quickLinkQuestionType }
    )
  }

  handleQuickLinkMenuItemClick = (quickLinkQuestionType) => {
    if (
      !quickLinkQuestionType ||
      quickLinkQuestionType === MORE_ITEM_TYPES.key
    ) {
      return this.handleCreate()
    }
    return this.handleCreate(quickLinkQuestionType)
  }

  handlePaginationChange = (page) => {
    const { sort } = this.props
    const { filter } = this.state
    const { receiveItems, limit } = this.props
    this.lastItemSearchFilter = filter
    receiveItems(filter, sort, page, limit)
  }

  renderPagination = () => {
    const { count, page } = this.props
    return (
      <Pagination
        simple={false}
        showTotal={(total, range) => `${range[0]} to ${range[1]} of ${total}`}
        onChange={this.handlePaginationChange}
        defaultPageSize={25}
        total={count}
        current={page}
      />
    )
  }

  toggleFilter = () => {
    const { isShowFilter } = this.state

    this.setState({
      isShowFilter: !isShowFilter,
    })
  }

  rejectNumberChecker = (testItems) => {
    let count = 0
    for (const i of testItems) {
      if (i.status === 'inreview') {
        count++
      }
    }
    return count
  }

  approveNumberChecker = (testItems) => {
    let count = 0
    for (const i of testItems) {
      if (i.status === 'inreview' || i.status === 'rejected') {
        count++
      }
    }
    return count
  }

  onClickNewTest = () => {
    const { createTestFromCart } = this.props
    createTestFromCart()
  }

  toggleSidebar = () =>
    this.setState((prevState) => ({ openSidebar: !prevState.openSidebar }))

  onSelectSortOption = (value, sortDir) => {
    const { limit, sort, receiveItems } = this.props
    const { filter } = this.state
    const updateSort = {
      ...sort,
      sortBy: value,
      sortDir,
    }
    this.updateFilterState(filter, updateSort)
    this.lastItemSearchFilter = filter
    receiveItems(filter, updateSort, 1, limit)
  }

  handleApproveItems = () => {
    const {
      approveOrRejectMultipleItem,
      selectedItems,
      setApproveConfirmationOpen,
    } = this.props
    if (selectedItems.length > 1) {
      setApproveConfirmationOpen(true)
    } else {
      approveOrRejectMultipleItem({ status: 'published' })
    }
  }

  renderCartButton = () => {
    const { approveOrRejectMultipleItem, userRole } = this.props
    if (userRole === roleuser.EDULASTIC_CURATOR) return null

    return (
      <>
        <FeaturesSwitch inputFeatures="isCurator" actionOnInaccessible="hidden">
          <CartButton
            onClick={() => approveOrRejectMultipleItem({ status: 'rejected' })}
            buttonText="Reject"
            numberChecker={this.rejectNumberChecker}
          />
          <CartButton
            onClick={this.handleApproveItems}
            buttonText="Approve"
            numberChecker={this.approveNumberChecker}
          />
        </FeaturesSwitch>
      </>
    )
  }

  renderFilterIcon = (isShowFilter) => {
    return (
      <EduIf condition={isShowFilter}>
        <EduThen>
          <FilterToggleBtn
            isShowFilter={!isShowFilter}
            toggleFilter={this.toggleFilter}
          />
        </EduThen>
        <EduElse>
          <StyledEduButton
            data-cy="smart-filter"
            isGhost={isShowFilter}
            onClick={this.toggleFilter}
            style={{
              height: '24px',
              marginRight: '10px',
              borderRadius: '15px',
            }}
          >
            <IconFilter width={15} height={15} />
            FILTERS
          </StyledEduButton>
        </EduElse>
      </EduIf>
    )
  }

  componentDidUpdate(prevProps) {
    const {
      searchId,
      page,
      count,
      loading,
      userId,
      enableSemanticSearch,
      enableDistrictContentFilter,
    } = this.props
    const { filter } = this.state
    if (searchId !== prevProps.searchId) {
      segmentApi.genericEventTrack('item search', {
        searchId,
        page,
        filterType: getFilterType(filter),
        semanticSearch: enableSemanticSearch,
        enableDistrictContentFilter,
        filter,
        libraryType: 'item',
        sessionId: window.sessionStorage.kid,
      })
      if (!loading && count === 0 && prevProps.searchId) {
        trackSearchZeroResults({
          filter: this.lastItemSearchFilter || filter,
          libraryType: 'item',
          userId,
        })
      }
    }
  }

  render() {
    const {
      windowWidth,
      creating,
      t,
      getCurriculumStandards,
      curriculumStandards,
      loading,
      count,
      userRole,
      sort = {},
    } = this.props
    const { filter } = this.state
    const { isShowFilter, openSidebar } = this.state
    return (
      <div>
        <SideContent
          onClick={this.toggleSidebar}
          open={openSidebar}
          showSliderBtn={false}
        />
        <SelectCollectionModal contentType="TESTITEM" />
        <ApproveConfirmModal contentType="TESTITEM" />
        <ListHeader
          renderBanner={
            <FeatureBannerPlaceholder placeholderId="item-library" />
          }
          onCreate={this.handleQuickLinkMenuItemClick}
          creating={creating}
          windowWidth={windowWidth}
          title={t('header:common.itemBank')}
          titleIcon={IconItemLibrary}
          renderExtra={this.renderCartButton}
          renderFilterIcon={this.renderFilterIcon}
          newTest={this.onClickNewTest}
          toggleSidebar={this.toggleSidebar}
          allowQuickItemLinks
        />
        <Container>
          <ItemFilter
            onSearchFieldChange={this.handleSearchFieldChange}
            onSearchInputChange={this.handleSearchInputChange}
            onSearch={this.handleSearch}
            onClearSearch={this.handleClearSearch}
            onLabelSearch={this.handleLabelSearch}
            windowWidth={windowWidth}
            search={filter}
            getCurriculumStandards={getCurriculumStandards}
            curriculumStandards={curriculumStandards}
            items={
              userRole === roleuser.EDULASTIC_CURATOR
                ? [filterMenuItems[0]]
                : filterMenuItems
            }
            toggleFilter={this.toggleFilter}
            t={t}
            itemCount={count}
            showFilter={
              windowWidth < SMALL_DESKTOP_WIDTH ? !isShowFilter : isShowFilter
            }
          />
          <ListItems isShowFilter={isShowFilter}>
            <EduIf condition={isShowFilter}>
              <MobileFilterIcon>
                {this.renderFilterIcon(isShowFilter)}
              </MobileFilterIcon>
            </EduIf>
            <SearchInputWithTooltip
              onSearchInputChange={this.handleSearchInputChange}
              value={filter.searchString}
            />
            <Element>
              <ContentWrapper borderRadius="0px" padding="0px">
                {loading && <Spin size="large" />}
                <>
                  <ItemsMenu>
                    <EduIf condition={!isShowFilter}>
                      <MobileFilterIcon>
                        {this.renderFilterIcon(isShowFilter)}
                      </MobileFilterIcon>
                    </EduIf>
                    <PaginationInfo>
                      <span>{count}</span>
                      <span>{t('author:component.item.itemsFound')}</span>
                    </PaginationInfo>
                    <HeaderFilter
                      search={_.omit(filter, [
                        'isSingaporeMath',
                        'type',
                        'testCategories',
                      ])}
                      handleCloseFilter={(type, value) =>
                        this.handleSearchFieldChange(type)(value)
                      }
                      type="testitem"
                    />
                    <SortMenu
                      options={sortOptions.itemList}
                      onSelect={this.onSelectSortOption}
                      sortDir={sort.sortDir}
                      sortBy={sort.sortBy}
                    />
                    <Actions type="TESTITEM" />
                  </ItemsMenu>

                  {!loading && (
                    <ScrollbarContainer>
                      <ItemListContainer
                        windowWidth={windowWidth}
                        search={filter}
                      />
                      {count > 10 && (
                        <PaginationContainer>
                          {this.renderPagination()}
                        </PaginationContainer>
                      )}
                    </ScrollbarContainer>
                  )}
                </>
              </ContentWrapper>
            </Element>
          </ListItems>
        </Container>
      </div>
    )
  }
}

Contaier.propTypes = {
  limit: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  receiveItems: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  createItem: PropTypes.func.isRequired,
  windowWidth: PropTypes.number.isRequired,
  creating: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  curriculums: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      curriculum: PropTypes.string.isRequired,
      grades: PropTypes.array.isRequired,
      subject: PropTypes.string.isRequired,
    })
  ).isRequired,
  getCurriculums: PropTypes.func.isRequired,
  getCurriculumStandards: PropTypes.func.isRequired,
  curriculumStandards: PropTypes.array.isRequired,
  clearDictStandards: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  setDefaultTestData: PropTypes.func.isRequired,
}

const enhance = compose(
  withWindowSizes,
  withNamespaces(['author', 'header']),
  connect(
    (state) => ({
      limit: getTestsItemsLimitSelector(state),
      page: getTestsItemsPageSelector(state),
      count: getTestsItemsCountSelector(state),
      loading: getTestItemsLoadingSelector(state),
      creating: getTestItemCreatingSelector(state),
      curriculums: getCurriculumsListSelector(state),
      curriculumStandards: getStandardsListSelector(state),
      defaultGrades: getDefaultGradesSelector(state),
      defaultSubject: getDefaultSubjectSelector(state),
      interestedGrades: getInterestedGradesSelector(state),
      interestedSubjects: getInterestedSubjectsSelector(state),
      interestedCurriculums: getAllInterestedCurriculumsSelector(state),
      sort: getSortFilterStateSelector(state),
      passageItems: state.tests.passageItems || [],
      userFeatures: getUserFeatures(state),
      collections: getCollectionsSelector(state),
      userRole: getUserRole(state),
      selectedItems: getSelectedItemSelector(state),
      userId: getUserId(state),
      districtId: getUserOrgId(state),
      test: getTestEntitySelector(state),
      searchId: getSearchIdSelector(state),
      enableSemanticSearch: isSemanticSearchEnabledSelector(state),
      enableDistrictContentFilter: isDistrictContentFilterEnabledSelector(
        state
      ),
    }),
    {
      receiveItems: (search, sort, page, limit) => {
        const _search = {
          ...search,
          standardIds: search?.standardIds?.map((item) => item._id) || [],
        }
        delete _search.isSingaporeMath
        delete _search.type
        delete _search.testCategories
        return receiveTestItemsAction(_search, sort, page, limit)
      },
      createItem: createTestItemAction,
      getCurriculums: getDictCurriculumsAction,
      getCurriculumStandards: getDictStandardsForCurriculumAction,
      clearDictStandards: clearDictStandardsAction,
      setDefaultTestData: setDefaultTestDataAction,
      udpateDefaultSubject: updateDefaultSubjectAction,
      updateDefaultGrades: updateDefaultGradesAction,
      checkAnswer: previewCheckAnswerAction,
      showAnswer: previewShowAnswerAction,
      getAllTags: getAllTagsAction,
      createTestFromCart: createTestFromCartAction,
      updateSearchFilterState: updateSearchFilterStateAction,
      approveOrRejectMultipleItem: approveOrRejectMultipleItemAction,
      setApproveConfirmationOpen: setApproveConfirmationOpenAction,
      getDefaultTestSettings: getDefaultTestSettingsAction,
      setTestData: setTestDataAction,
    }
  )
)

export default enhance(Contaier)
